import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

const accord = document.querySelectorAll('.accord');
const accordionInstances = new WeakMap();

accord?.forEach(list => {
  const instance = new Accordion(list, {
    openOnInit: [0],
    duration: 400,
    showMultiple: false,
  });

  accordionInstances.set(list, instance);

  const panels = list.querySelectorAll('.ac-panel');
  panels.forEach(panel => {
    panel.addEventListener('click', event => {
      event.stopPropagation();
    });
  });
});

export function closeAccordionsIn(container) {
  container.querySelectorAll('.accord').forEach(list => {
    const instance = accordionInstances.get(list);
    if (instance) instance.closeAll();
  });
}

const qnaMain = document.querySelector('.qna__main');
const qnaAccordionInstances = new WeakMap();

function initQnaAccordion() {
  if (!qnaMain) return;

  const accordions = [...qnaMain.querySelectorAll('.faq__accord')];

  if (!accordions.length) return;

  accordions.forEach((accord, index) => {
    const instance = new Accordion(accord, {
      openOnInit: index === 0 ? [0] : [],
      duration: 400,
      showMultiple: false,
    });

    qnaAccordionInstances.set(accord, instance);

    accord.addEventListener('click', e => {
      const trigger = e.target.closest('.ac-trigger');
      if (!trigger) return;

      accordions.forEach(otherAccord => {
        if (otherAccord !== accord) {
          const otherInstance = qnaAccordionInstances.get(otherAccord);
          if (!otherInstance) return;

          const items = [...otherAccord.querySelectorAll('.ac')];

          items.forEach((item, itemIndex) => {
            if (item.classList.contains('is-active')) {
              otherInstance.close(itemIndex);
            }
          });
        }
      });
    });

    accord.querySelectorAll('.ac-panel').forEach(panel => {
      panel.addEventListener('click', e => e.stopPropagation());
    });
  });
}

export function closeQnaAccordionsIn(container) {
  container.querySelectorAll('.faq__accord').forEach(list => {
    const instance = qnaAccordionInstances.get(list);
    if (instance) instance.closeAll();
  });
}

document.addEventListener('DOMContentLoaded', initQnaAccordion);

// <ul class="__accord accord">
//   <li class="ac">
//     <div class="ac-trigger">
//       <div class="__head">
//         <button
//           type="button"
//           class="ac-toggle"
//           aria-label="Toggle accordion"
//         ></button>
//       </div>

//       <div class="ac-panel">
//         <div class="__content"></div>
//       </div>
//     </div>
//   </li>
// </ul>
